import React from 'react'
import { Container, Typography, Tabs, TabItemType, ModalTitle } from '@cleartrip/ct-design-components'
import { FareFamilyHeaderType } from '@/types/srp'
import SegmentTab from './SegmentTab'
import { FARE_TYPE_COMMON_FOR_FULL_TRIP, INTERSTITIAL_SPL_RT_LABEL, NOTE_WITH_COLON } from '@/constants/Srp'

type FareFamilyHeaderProps = {
    headerDetails: FareFamilyHeaderType[]
    selectedTabIndex: number
    setSelectedTabIndex: (tabKey: number) => void
    isSpecialRT: boolean
}

const FareFamilyHeader: React.FC<FareFamilyHeaderProps> = ({
    headerDetails,
    selectedTabIndex,
    setSelectedTabIndex,
    isSpecialRT
}) => {
    const showTabs = headerDetails.length > 1 && !isSpecialRT
    const tabList: TabItemType[] = headerDetails.map((headerDetail, index) => {
        return {
            tabKey: index,
            label: <SegmentTab {...headerDetail} />
        }
    })

    const onTabClick: (e: Event, selectValue: TabItemType) => void = (_, tab) => {
        setSelectedTabIndex(Number(tab.tabKey))
    }
    return (
        <ModalTitle styleConfig={{
            root: {
                css: {
                    padding: '24px 24px 0 24px'
                }
            }
        }}>
            <Container>
                <Container className="flex flex-middle flex-gap-6">
                    <Typography variant="HM1" >
                        {isSpecialRT ? INTERSTITIAL_SPL_RT_LABEL : "Select your fare"}
                    </Typography>
                    {isSpecialRT && (
                        <Container backgroundColor='#FFF5DD' className='flex flex-middle px-4 py-3 br-12' columnGap={4}>
                            <Typography variant='B3' className='fw-600'>
                                {NOTE_WITH_COLON}{' '}
                            </Typography>
                            <Typography variant='P3'>{FARE_TYPE_COMMON_FOR_FULL_TRIP}</Typography>
                        </Container>
                    )}
                </Container>
                {!isSpecialRT && (
                    showTabs ? (
                        <Tabs
                            tabList={tabList}
                            selectedTabIndex={selectedTabIndex}
                            tabSize="large"
                            styleConfig={{
                                root: {
                                    css: {
                                        paddingLeft: '16px'
                                    }
                                },
                                tabItem: {
                                    root: {
                                        css: {
                                            height: 'auto',
                                            textAlign: 'left'
                                        }
                                    }
                                }
                            }}
                            onClick={onTabClick}
                        />
                    ) : (
                        <Container className="mt-5 mb-4">
                            <Container >
                                <SegmentTab {...headerDetails[0]} />
                            </Container>
                            {/* <Divider borderColor="#e7e7e7" /> */}
                        </Container>
                    )
                )}
          
            </Container>
        </ModalTitle>
    )
}

export default FareFamilyHeader
